<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="tasks.data"
      style="width: 100%"
      row-key="id"
      :tree-props="{children: 'task_items'}"
      @sort-change="handleSortChange"
      @selection-change="handleSelectionChange">
      >
      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="task"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :task="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="tasks.per_page"
        layout="total, prev, pager, next"
        :total="tasks.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'start_date',
        order: 'ascending',
      },
      idsToDelete: [],
    };
  },
  computed: {
    tasks() {
      return this.$store.getters['task/tasks'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['task/tableConfig']));
    },
    loading() {
      return this.$store.getters['task/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('task/setFilterString', '');
    this.$store.commit('task/setCurrentPage', this.currentPage);
    this.$store.commit('task/setSorting', this.currentSort);
    await this.$store.dispatch('task/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('task/setCurrentPage', val);
      this.$store.dispatch('task/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      this.$store.commit('task/setSorting', { prop, order });
      this.$store.dispatch('task/fetchAll');
    },
    handleSelectionChange(values) {
      this.idsToDelete = values.map(task => task.id);
    }
  },
};
</script>

